/**
  * 实验权限模块接口列表
  */

import base from '../base'; // 导入接口域名列表
import axios from '../../request/http'; // 导入http中创建的axios实例

const expApi = {
    GetExperAuthDataTree: `${base.qa}/ExperAuth/GetExperAuthDataTree`,
    SaveExperAuthData: `${base.qa}/ExperAuth/SaveExperAuthData`,

}

const exp = {
    GetExperAuthDataTree (roleid, specid, classid) {
        return axios.get(expApi.GetExperAuthDataTree, { params: { roleid, specid, classid } })
    },
    SaveExperAuthData (params) {
        return axios.post(expApi.SaveExperAuthData, params)
    },
}


export default exp;